export const iconFontAwesomeMapsPlane = (
	<i className="fa-solid fa-plane"></i>
);
